define(["../transitionsModule", "text!./attachmentMandatoryModal.html",], function (module, template) {
    "use strict";

    return module.service("attachmentMandatoryModal", ["$modal", "transitionService", "messagesModal", function ($modal, transitionService, messagesModal) {
        return function (transitionId) {
            return $modal.open({
                size: "lg",
                backdrop: "static",
                template: template,
                controller: ["$scope", $scope => {
                    $scope.newComment = {};
                    $scope.save = () => {
                        let comment = $scope.newComment;
                        if (comment && (comment.files && !comment.content)) {
                            return messagesModal("dialog.error", "monitoring.transition.comment.mandatory.to.attachment");
                        }
                        return transitionService.accomplishTransitions([transitionId], Date.now(), comment)
                            .then((restRemoteMessage) => {
                                if (restRemoteMessage.some(remoteMessage => !remoteMessage.result)) {
                                    return;
                                }
                                return $scope.$close();
                            });
                    };
                }]
            }).result;
        }
    }])
});